import api from '@/services/api'
import { getOptionsString } from '@/services/api/helpers'

const createEpisode = (podcastId, payload) => {
  return api.post(`/podcasts/${podcastId}/episodes`, payload).then(async ({data}) => {
    return data
  })
}

const getCreationKeys = async (podcast) => {
  return api.get(`/podcasts/${podcast.id}/episodes`).then(async ({data}) => {
    let authors = podcast.authors.collection

    if (data.create) {
      data.create.input.authors = {
        value: {
          associated: [],
          available: authors.map(a => {
            return {
              label: a.name,
              value: a.id
            }
          })
        }
      }
    }
    return data.create && data.create.input
  })
}

const getEpisode = (episodeId) => {
  return api.get(`/episodes/${episodeId}`).then(async ({data}) => {
    const episode = await getEpisodeMisc(data)
    return episode
  }).catch((err) => {
    console.error('Episode does not exist', err)
    return {
      id: 'not-found'
    }
  })
}

const getEpisodeMisc = async (data) => {
  data.season = await getMeta(data.season.href)
  data.podcast = await getMeta(data.podcast.href)
  data.isTranscoding = data.status === 'transcoding'
  data.status = getEpisodeStatus(data)

  if (data.campaign_preview) {
    data.campaign_preview = await getMeta(data.campaign_preview.href)
  }

  return data
}

const getEpisodes = (podcastId, options) => {
  let optionsString = getOptionsString(options)

  let path = `/podcasts/${podcastId}/episodes?${optionsString}`

  return api.get(path).then(({data}) => {
    return data
  })
}

const getLastEpisode = (podcastId, options = {}) => {
  let path = `/podcasts/${podcastId}/episodes?sort=latest&limit=1`
  return api.get(path).then(({data}) => {
    return data.collection[0]
  })
}

const getTopEpisode = (podcastId, options = {}) => {
  let path = `/analytics?podcast=${podcastId}`
  return api.get(path).then(({data}) => {
    const sortedEpisodes = data.episodes.top_10.sort((a, b) => {
      return a.rank - b.rank
    })

    return sortedEpisodes[0]
  })
}

const getMeta = (path) => api.get(path).then(({data}) => data)

const updateEpisode = (episodeId, payload) => {
  return api.post(`/episodes/${episodeId}`, payload)
    .then(({data}) => {
      return data
    })
    .catch((err) => {
      console.error('Update episode failure:', err)
      throw err
    })
}

const updateEpisodeMeta = (path, payload) => {
  return api.post(path, payload).then(({data}) => {
    return data
  })
}

const updateEpisodeFeed = (path, payload) => {
  return api.post(path, payload).then(({ data}) => {
    return data
  })
}

const publishEpisode = (episodeId) => {
  let path = `/episodes/${episodeId}/publish`
  return api.post(path, {}).then(({data}) => {
    return data
  })
}

const scheduleEpisode = (episodeId, timestamp) => {
  let path = `/episodes/${episodeId}/schedule`
  return api.post(path, { timestamp }).then(({data}) => {
    return data
  })
}

const unscheduleEpisode = (episodeId) => {
  let path = `/episodes/${episodeId}/unschedule`
  return api.post(path, {}).then(({data}) => {
    return data
  })
}

const deleteEpisode = (episodeId) => {
  return api.delete(`/episodes/${episodeId}`).then(({data}) => {
    return data
  })
}

const bulkDeleteEpisodes = (podcastId, episodes) => {
  return api.delete(`/podcasts/${podcastId}/episodes`, {params: {episodes}}).then(({data}) => {
    return data
  })
}

// ////////
// Helpers
// ////////

function getEpisodeStatus (ep) {
  if (ep.is_hidden) {
    return 'private'
  } else if (ep.published_at) {
    return 'live'
  } else if (ep.scheduled_for) {
    return 'scheduled'
  } else if (ep.status === 'transcoding_error') {
    return 'transcoding_error'
  } else {
    return 'draft'
  }
}

export default {
  createEpisode,
  getCreationKeys,
  getEpisode,
  getEpisodeMisc,
  getEpisodes,
  getLastEpisode,
  getTopEpisode,
  getMeta,
  updateEpisode,
  updateEpisodeMeta,
  publishEpisode,
  scheduleEpisode,
  unscheduleEpisode,
  deleteEpisode,
  bulkDeleteEpisodes,
  updateEpisodeFeed,
  // For the ONE thing that requires a delete
  deleteFromEpisode: (path, payload) => api.delete(path, {params: payload}).then(res => res.data)
}
